import React from 'react';
import { Box, Typography } from '@drone-js/core';
import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps, InCitySearchOverlayProps as Props } from 'component/common/InCitySearchTopActivities/InCitySearchTopActivities.selectors';
import { StringFormatter } from '@agoda/react-handyman';
import { ActivityCardProps } from 'core/type/ActivityCard.types';
import { CmsValue, Geo } from 'core/type/BootstrapConfig.types';
import { CategoryId, CategoryIcon } from 'core/type/Category.types';
import SuggestionItem from 'component/common/SuggestionItem/SuggestionItem';
import { getCategoryNameFromActivity } from 'core/utils/categoryUtils';

interface PopularActivitiesResultItemProps {
    cms: CmsValue;
    result: ActivityCardProps;
    isSetRecentSearch: boolean;
    onSelect: (result: ActivityCardProps, geo: Geo, isSetRecentSearch: boolean) => void;
    geo?: Geo;
}

const PopularActivitiesResultItem: React.FC<PopularActivitiesResultItemProps> = React.memo((props) => {
    const activity = props.result;
    if (!activity || !props.geo) return null;

    const cityName = props.geo.cityName || '';
    const assets = CategoryIcon[activity.categories?.[0] as CategoryId]?.id || CategoryIcon[CategoryId.Attractions].id;
    const title = activity.title;
    const categoryName = getCategoryNameFromActivity(activity, props.cms);
    const subTitle = categoryName ? StringFormatter.format(props.cms[320129], categoryName, cityName) : cityName;

    const clickHandler = () => props.geo && props.onSelect(activity, props.geo, props.isSetRecentSearch);

    return <SuggestionItem elementName="activities-in-city-popular-item" onSelect={clickHandler} title={title} subTitle={subTitle} icon={assets} />;
});
PopularActivitiesResultItem.displayName = 'PopularActivitiesResultItem';

const InCitySearchTopActivitiesComponent: React.FC<Props> = (props: Props) => {
    const { geo, popularActivities, cms, inputText, onResultClick } = props;
    const isShowKeywordSearch = inputText.length > 0;
    const isShowPopularActivities = (geo && popularActivities && popularActivities.length > 0 && !isShowKeywordSearch) || false;
    const cityName = geo?.cityName || '';

    if (!isShowPopularActivities) return null;

    return (
        <Box data-testid="in-city-top-activities-container" maxWidth="744px" mx="auto" px={props.isDesktop ? '12' : '12'} pb="0" mb="0" width="100%">
            <Typography variant="body-default-strong" py="12" px={props.isDesktop ? '0' : '12'}>
                {StringFormatter.format(cms[153679], cityName)}
            </Typography>
            {popularActivities?.map((pa) => (
                <PopularActivitiesResultItem key={pa.id} result={pa} onSelect={onResultClick} geo={geo} cms={cms} isSetRecentSearch={props.isSearchBoxFeatureGroup} />
            ))}
        </Box>
    );
};

InCitySearchTopActivitiesComponent.displayName = 'InCitySearchTopActivitiesComponent';

const InCitySearchTopActivities = connect(mapStateToProps, mapDispatchToProps)(InCitySearchTopActivitiesComponent);

export default InCitySearchTopActivities;
